import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  static values = { url: String }

  async generate() {
    const response = await fetch(this.urlValue, { headers: { Accept: "application/json" } })
    const data = await response.json()
    this.inputTarget.value = data.nickname
    this.inputTarget.focus()
  }
}
